import React from 'react';

const AboutOurTeam = () => {
    return (
        <div id="our-team" className="block spacer p-top-xl">
            <div className="title">
                <h2 className="hr">Our Team</h2>
            </div>

            <div className="row gutter-width-sm with-pb-md">
                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                    <div className="team-member">
                        <div className="img object-fit">
                            <div className="object-fit-cover">
                                <img src="assets/img/placeholder/507x600.jpg" alt="Rosie Ford" />
                            </div>
                        </div>

                        <div className="team-member-content">
                            <div className="team-member-position">
                                <p>Makeup Artist</p>
                            </div>

                            <h4 className="team-member-t-head">Rosie Ford</h4>

                            <div className="team-member-description">
                                <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots.</p>
                            </div>
                        </div>

                        <nav className="team-member-nav-items">
                            <ul className="nav">
                                <li className="nav-item">
                                    <a title="Facebook" href="https://www.facebook.com/adveits/"><i className="fab fa-facebook-f"></i></a>
                                </li>

                                <li className="nav-item">
                                    <a title="LinkedIn" href="https://www.linkedin.com/company/18135051/"><i className="fab fa-linkedin-in"></i></a>
                                </li>

                                <li className="nav-item">
                                    <a title="Instagram" href="https://www.instagram.com/adveits/"><i className="fab fa-instagram"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                    <div className="team-member">
                        <div className="img object-fit">
                            <div className="object-fit-cover">
                                <img src="assets/img/placeholder/507x600.jpg" alt="Tom Henders" />
                            </div>
                        </div>

                        <div className="team-member-content">
                            <div className="team-member-position">
                                <p>Hair Stylist</p>
                            </div>

                            <h4 className="team-member-t-head">Tom Henders</h4>

                            <div className="team-member-description">
                                <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots.</p>
                            </div>
                        </div>

                        <nav className="team-member-nav-items">
                            <ul className="nav">
                                <li className="nav-item">
                                    <a title="Facebook" href="https://www.facebook.com/adveits/"><i className="fab fa-facebook-f"></i></a>
                                </li>

                                <li className="nav-item">
                                    <a title="LinkedIn" href="https://www.linkedin.com/company/18135051/"><i className="fab fa-linkedin-in"></i></a>
                                </li>

                                <li className="nav-item">
                                    <a title="Instagram" href="https://www.instagram.com/adveits/"><i className="fab fa-instagram"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                    <div className="team-member">
                        <div className="img object-fit">
                            <div className="object-fit-cover">
                                <img src="assets/img/placeholder/507x600.jpg" alt="Lana Hemb" />
                            </div>
                        </div>

                        <div className="team-member-content">
                            <div className="team-member-position">
                                <p>Hair Stylist</p>
                            </div>

                            <h4 className="team-member-t-head">Lana Hemb</h4>

                            <div className="team-member-description">
                                <p>Contrary to popular belief, Lorem Ipsum is not simply random
                                    text. It has roots.</p>
                            </div>
                        </div>

                        <nav className="team-member-nav-items">
                            <ul className="nav">
                                <li className="nav-item">
                                    <a title="Facebook" href="https://www.facebook.com/adveits/"><i className="fab fa-facebook-f"></i></a>
                                </li>

                                <li className="nav-item">
                                    <a title="LinkedIn" href="https://www.linkedin.com/company/18135051/"><i className="fab fa-linkedin-in"></i></a>
                                </li>

                                <li className="nav-item">
                                    <a title="Instagram" href="https://www.instagram.com/adveits/"><i className="fab fa-instagram"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutOurTeam;
